import {gsap} from "gsap";
import {ScrollTrigger} from "gsap/ScrollTrigger";
import {SplitText} from "../SplitText.js";

export function timelineAnimation(timelineSectionClass) {
    const sections = document.querySelectorAll(timelineSectionClass);
    sections.forEach((section, index) => {
        const headlineWords = new SplitText(section.querySelector('.setting_heading_fill_in'), { type: "words" });
        let tl = gsap.timeline({
            scrollTrigger: {
                trigger: section,
                start: 'center center',
                end: '+=100%',
                scrub: 1,
                pin: true,
                anticipatePin: 1
            }
        });
        tl.to(section.querySelector('.settings-span'), {
            opacity: 1,
            duration: headlineWords.words.length
        })
            .fromTo(headlineWords.words, {
                opacity: 0.2,
            },{
                opacity: 1,
                stagger: 1,
            }, "<")
            .to("html",{
                ["--timeline-" + (index + 1)]: 1,
                duration: headlineWords.words.length
            }, "<")
        ScrollTrigger.refresh();
    })
}